<template>
  <div>
    <!-- 产品增加 -->
    <!-- <el-dialog :title="operate === 'edit'?'编辑产品':'添加产品'" :close-on-click-modal="false" :visible="currentStep=== 3" class="imgbox" width="40%" :append-to-body="true" :before-close="closeDialog"> -->
      <el-form label-width="130px" ref="ruleForm"  :rules="rules" :model="form">

        <el-row :span="24">
          <el-col :span="8">
            <el-form-item label="产品小图"  prop="flag">
              <uploadPicView :data="uploadPic.smallPic" />
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :span="24">
          <el-col :span="12">
             <el-form-item label="产品规格书" >
                <el-row>
                  <el-col>
                    <uploadFileView2 :file="uploadFile.productFile1"/>
                  </el-col>
                </el-row>
              </el-form-item>
          </el-col>
           <el-col :span="12">
            <el-form-item label="产品使用说明书" >
              <el-row>
                <el-col>
                  <uploadFileView2 :file="uploadFile.productFile2"/>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <!-- <div  slot="footer" class="dialog-footer" v-if="operate === 'edit'">
         <el-button type="primary" @click="nextStep('update')">修改</el-button>
      </div>
      <div v-else slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">重 置</el-button>
        <el-button  @click="prevStep">上一步</el-button>
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </div>
    </el-dialog> -->
    <ChooseTypeDrawe v-if="drawerFlag" :drawerFlag="drawerFlag" @closeDrawer="closeDrawer" @getData="receive"/>
  </div>
</template>
<script>
import { addProduct, editProduct } from '@/api/productRegistration'
import ChooseTypeDrawe from '@/components/product_control/chooseTypeDrawe'
import uploadFileView2 from '@/components/product_control/addProductDialog/uploadFileView2'
import uploadPicView from '@/components/product_control/addProductDialog/uploadPicView'
import eventBus from '@/assets/js/eventBus'
export default {
  props: {
    operate: {
      type: String
    },
    currentStep: {
      type: Number
    },
    expandDto: {
      type: Object
    },
    productDetail: {
      type: Object
    },
    refresh: {
      type: Boolean
    },
    step: {
      type: Object
    }
  },
  components: {
    ChooseTypeDrawe,
    uploadFileView2,
    uploadPicView
  },
  data () {
    return {
      tag: 0,
      form: {
        flag: true// 只是为了给产品小图一个星号
      },
      rules: {
        flag: [
          { required: true, message: '请选择图片', trigger: 'blur' }
        ]
      },
      focusStatus: true,
      autosize: { minRows: 6 }, // 设置textarea的最小高度
      nodeTypeOptions: [
        {
          nodeTypeName: '直连设备',
          nodeTypeKey: 0
        },
        {
          nodeTypeName: '网关子设备',
          nodeTypeKey: 1
        },
        {
          nodeTypeName: '网关设备',
          nodeTypeKey: 2
        }
      ],
      connectionTypeOptions: [
        {
          connectionTypeName: 'Wi-Fi',
          connectionTypeKey: 1
        },
        {
          connectionTypeName: 'Zigbee',
          connectionTypeKey: 2
        },
        {
          connectionTypeName: '蓝牙',
          connectionTypeKey: 3
        },
        {
          connectionTypeName: '蜂窝网(2G/3G/4G/5G)', // 蜂窝网ETHERNET
          connectionTypeKey: '4'
        },
        {
          connectionTypeName: '以太网',
          connectionTypeKey: '5'
        },
        {
          connectionTypeName: 'LiRaWAN',
          connectionTypeKey: '6'
        },
        {
          connectionTypeName: '其他',
          connectionTypeKey: '7'
        }
      ],
      dataFormatOptions: [
        {
          dataFormatName: 'ICA标准数据格式(Alink JSON)',
          dataFormatKey: 1
        },
        {
          dataFormatName: '透传/自定义',
          dataFormatKey: 0
        }
      ],
      authTypeOptions: [
        {
          authTypeName: '设备密钥',
          authTypeKey: 0
        },
        {
          authTypeName: 'X.509证书',
          authTypeKey: 1
        }
      ],
      drawerFlag: false, // 抽屉开关
      status: false,
      uploadPic: {
        smallPic: {
          fileToken: '',
          validate: true
        }
      },
      uploadFile: {
        productFile1: {
          fileToken: '',
          validate: true,
          fileList: []
        },
        productFile2: {
          fileToken: '',
          validate: true,
          fileList: []
        }
      }
    }
  },
  created () {
    eventBus.$on('mergeParams', this.nextStep)
    eventBus.$on('resetFields', this.resetFields)
    this.initData()
  },
  watch: {
    refresh () {
      console.log('第三步骤:refresh变化了', this.expandDto)
      this.initData()
    },
    tag: {
      handler (val) {
        if (val === 0) {
          console.log('不需要验证')
          this.status = false
        } else {
          this.status = true
        }
      }
    }
  },
  methods: {
    update () {
      const params = Object.assign({}, this.productDetail)
      const expandDto = Object.assign({}, params.expandVo)
      // 删除多余参数
      delete params.expandVo
      if (expandDto && expandDto.agreementFile) {
        delete expandDto.agreementFile
      }
      params.expandDto = expandDto
      console.log('更新的params：', params)
      editProduct({ params: params }).then(
        res => {
          if (res.data.code === 200) {
            this.$message({
              type: 'success',
              message: '产品更新成功'
            })
            this.$emit('delImg')
            this.$emit('closeDialog', 1)
          }
        }
      )
    },
    initData () {
      // 产品小图
      const smalPic = {
        fileToken: this.expandDto.mainPic,
        validate: true,
        fileList: [{
          fileUrl: this.expandDto.picUrl
        }]
      }
      const uploadPic = {
        smallPic: smalPic
      }
      this.uploadPic = uploadPic

      if (this.expandDto.productSpecification) {
        this.uploadFile.productFile1 = {
          fileToken: this.expandDto.productSpecification,
          validate: true,
          fileList: [{
            name: '产品规格书'
          }]
        }
      }
      if (this.expandDto.productGuide) {
        this.uploadFile.productFile2 = {
          fileToken: this.expandDto.productGuide,
          validate: true,
          fileList: [{
            name: '产品使用说明书'
          }]
        }
      }
    },
    resetFields () {
      this.uploadFile.productFile1 = {
        fileToken: '',
        validate: true,
        fileList: []
      }
      this.uploadFile.productFile2 = {
        fileToken: '',
        validate: true,
        fileList: []
      }
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },
    prevStep () {
      this.$emit('prevStep', 2)
    },
    addUploadFile () {
      const fileItem = { id: new Date().getTime() + Math.random(), fileList: [] }
      this.uploadFileList.push(fileItem)
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    nextStep (update) {
      // 每次验证前先把标记置为true
      this.uploadPic.smallPic.validate = true
      // this.uploadFile.productFile1.validate = true
      // this.uploadFile.productFile2.validate = true
      // 验证文件列表是否都通过
      eventBus.$emit('validatePicList')
      eventBus.$emit('validateProductFileList')
      const params = {
        mainPic: '',
        productSpecification: '',
        productGuide: ''
      }
      if (!this.uploadPic.smallPic.validate) { // 小图上传验证未通过
        return
      } else {
        params.mainPic = this.uploadPic.smallPic.fileToken
      }
      if (this.uploadFile.productFile1.fileList && this.uploadFile.productFile1.fileList.length > 0) {
        params.productSpecification = this.uploadFile.productFile1.fileToken
      }
      if (this.uploadFile.productFile2.fileList && this.uploadFile.productFile2.fileList.length > 0) {
        params.productGuide = this.uploadFile.productFile2.fileToken
      }
      Object.assign(this.expandDto, params)
      console.log('步骤3，this.expandDto：', this.expandDto)
      this.step.next = true
      // todo调用接口
      // 验证通过
      // if (update === 'update') {
      //   this.update()
      // } else {
      //   this.$emit('nextStep', 4)
      // }
    },
    // 提交
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) { // 验证成功
          const addParams = Object.assign({}, this.form)
          if (this.tag === 0) {
            delete addParams.productKey
          }
          console.log(addParams)
          const params = {
            params: addParams
          }
          addProduct(params).then(
            res => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '产品创建成功'
                })
                this.$emit('closeDialog', 1)
              }
            }
          )
        }
      })
    },
    // 重置
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    // 打开抽屉
    openDrawer (e) {
      this.drawerFlag = true
      this.focusStatus = false
    },
    // 关闭抽屉
    closeDrawer () {
      this.drawerFlag = false
      this.focusStatus = true
    },
    // 获取抽屉传过来的值
    receive (val) {
      console.log('子组件数据', val)
      this.form.categoryName = val.categoryName
      this.form.categoryKey = val.categoryKey
      this.drawerFlag = false
      this.focusStatus = true
    }
  }
}
</script>

<style lang='less' scoped>
.avatar-uploader-icon {
     font-size: 14px;
    color:white;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color:#409EFF;
    border-radius: 25px;
    cursor: pointer;
  }
  .el-button{
    margin-left: 10px;
  }
</style>
